import { Component } from "react";
import headquartersStyle from './headquarters.module.css';

class Headquarters extends Component {
    title = 'Headquarters';

    render() {
        return (
            <>
                <h1 className={`display-2 fw-bolder text-capitalize ${headquartersStyle.title}`}>{this.title}</h1>
                <div className={`m-auto mt-5 ${headquartersStyle.map}`}>
                    <iframe id="google-map" src="https://maps.google.com/maps?v=2&f=q&ie=UTF8&t=m&iwloc=&q=Long+Island%2c+NY%2c+USA&hl=en&z=14&source=s_q&output=embed"
                        height="100%" width="100%"></iframe>
                </div>
            </>
        );
    }
}

export default Headquarters;